<template>
  <div class="updateTenantModal">
    <vs-popup :active.sync="isActiveLocal" :button-close-hidden="false" title="Editar Features" @close="isActiveLocal = false">
      <div class="mb-5">
        <label>Plano</label>
        <v-select
          v-model="enabledPlan"
          :options="defaultPlans"
          :dir="$vs.rtl ? 'rtl' : 'ltr'"
          class="w-full"
          name="plan"
          label="text"
          placeholder=" "
          :clearable="false"
          :searchable="true"
          :reduce="option => option.value"
        />
      </div>

      <div class="flex flex-row mb-5 justify-between">
        <div>
          <label class="vs-input--label">Limite de Usuários</label>
          <vs-input-number class="userLimit" v-model="userLimit" min="0" max="100" step="5"/>
        </div>

        <div>
          <label class="vs-input--label">Limite de Atendimentos</label>
          <vs-input-number class="userLimit" v-model="ticketLimit" min="0" max="7000" step="500"/>
        </div>
      </div>

      <div class="w-full">
        <label>Features</label>
        <div class="featureCheckboxList">
          <div v-for="(key, value) in featureSupport" :key="key" class="mb-2">
            <vs-checkbox v-model="currentFeatures[key - 1]" :disabled="value === 'whatsapp' || (enabledPlan && enabledPlan !== 'ON-DEMAND')">
              <span> {{ formattedFeatures[value] }} </span>
            </vs-checkbox>
          </div>
        </div>
      </div>

      <vs-button class="mt-2" type="filled" @click="updateFeatures">Salvar</vs-button>
    </vs-popup>

    <div class="w-full" v-if="!isPopup">
      <div class="mb-5">
        <label>Plano</label>
        <v-select
          v-model="enabledPlan"
          :options="defaultPlans"
          :dir="$vs.rtl ? 'rtl' : 'ltr'"
          class="w-full"
          name="plan"
          label="text"
          placeholder=" "
          :clearable="false"
          :searchable="true"
          :reduce="option => option.value"
        />
      </div>

      <div class="flex flex-row mb-5 justify-between">
        <div>
          <label class="vs-input--label">Limite de Usuários</label>
          <vs-input-number class="userLimit" v-model="userLimit" min="0" max="100" step="5"/>
        </div>

        <div>
          <label class="vs-input--label">Limite de Atendimentos</label>
          <vs-input-number class="userLimit" v-model="ticketLimit" min="0" max="7000" step="500"/>
        </div>
      </div>

      <div class="w-full">
        <label>Features</label>
        <div class="featureCheckboxList">
          <div v-for="(key, value) in featureSupport" :key="key" class="mb-2">
            <vs-checkbox v-model="currentFeatures[key - 1]" :disabled="value === 'whatsapp' || (enabledPlan && enabledPlan !== 'ON-DEMAND')">
              <span> {{ formattedFeatures[value] }} </span>
            </vs-checkbox>
          </div>
        </div>
      </div>

      <div class="w-full mt-5 flex justify-center mb-5" v-if="canSee('feature-update')">
        <vs-button type="filled" size="small" @click="updateFeatures">Salvar</vs-button>
      </div>
    </div>
  </div>
</template>

<script>

import vSelect from 'vue-select';
import {hasPermissionBackOffice} from "@/utils";

export default {
  name: 'UpdateTenant',
  emits: ['setState'],
  components: { vSelect },
  data() {
    return {
      userLimit: 0,
      ticketLimit: 0,
      currentFeatures: new Array(9).fill(false),
      featureSupport: {
        'orders': 1,
        'erps': 2,
        'services': 3,
        'catalog': 4,
        'maria': 5,
        'sms': 6,
        'email': 7,
        'boehringer': 8,
        'pharmacovigilance': 9,
        'whatsapp': 10
      },
      formattedFeatures: {
        'orders': 'Pedidos',
        'erps': 'ERPs',
        'services': 'Serviços',
        'catalog': 'Catálogo',
        'maria': 'Maria',
        'sms': 'SMS',
        'email': 'Email',
        'boehringer': 'Boehringer',
        'pharmacovigilance': 'Farmacovigilância',
        'whatsapp': 'Campanhas Whatsapp',
      }
    }
  },
  props: {
    isActive: {
      type: Boolean,
      default: false,
      required: true
    },
    isPopup: {
      type: Boolean,
      required: false,
      default: true
    },
    features: {
      type: Array,
      default: [],
      required: true
    },
    tenant: {
      required: false,
      validator: prop => typeof prop === 'object' || prop === null,
      default() { return {}; }
    },
    defaultPlans: {
      required: false,
      validator: prop => typeof prop === 'object' || prop === null,
      default() { return []; }
    },
    enabledPlan: {
      required: false,
      validator: prop => typeof prop === 'string' || prop === null,
      default() { return false; }
    }
  },
  computed: {
    isActiveLocal: {
      get() {
        return this.isActive;
      },
      set(newVal) {
        this.$emit('setState', newVal);
      }
    }
  },
  watch: {
    features() {
      this.loadFeatures(true)
    },
    isActiveLocal(newVal) {
      if (newVal) {
        this.userLimit = (this.tenant.user_limit || 0);
        this.ticketLimit = (this.tenant.ticket_limit || 0);
      }
      this.loadFeatures(newVal)
    }
  },
  methods: {
    canSee(word) {
      return hasPermissionBackOffice(`tenant-list-${word}`);
    },
    loadFeatures(newVal) {
      this.currentFeatures = new Array(10).fill(false);
      if (newVal && this.features && this.features.length) {
        this.features.forEach(item => {
          if (!['websocket', 'status_notification', 'skip_downgrade_provisioner', 'premium_support', 'campaigns', 'cloud', 'messaging'].includes(item.name)) {
            this.currentFeatures[this.featureSupport[item.name] - 1] = item.enabled && item.enabled == 'true';
          }
        });
      }
    },
    updateFeatures() {
      if (this.enabledPlan){
        this.$emit('setPlan', { plan: this.enabledPlan, user: this.userLimit, ticket: this.ticketLimit });
        this.$emit('setState', false);
        if (this.enabledPlan !== 'ON-DEMAND') { return; }
      }

      const parsedFeatures = {};
      this.currentFeatures.forEach((value, index) => parsedFeatures[index + 1] = value);

      const computed = [];
      const notComputed = Object.values(this.featureSupport);

      this.features.forEach(feature => {
        computed.push(this.featureSupport[feature.name]);

        if (parsedFeatures[this.featureSupport[feature.name]] === JSON.parse(feature.enabled)) {
          delete parsedFeatures[this.featureSupport[feature.name]];
        }
      });

      (notComputed.filter(id => !computed.includes(id))).forEach(id => {
        if (!parsedFeatures[id]) delete parsedFeatures[id];
      });

      this.$emit('setState', false, parsedFeatures);
    }
  }
}
</script>

<style lang="scss">
.featureCheckboxList {
  display: flex;
  flex-wrap: wrap;
  gap: 5px;
  max-width: 100%;
}

.featureCheckboxList .mb-2 {
  flex: 1 1 calc(50% - 8px);
}

.userLimit {
  width: 7.6em;
}

</style>